import { singleton, inject } from "tsyringe";

// shared
import type { HttpAdapter } from "@/shared/libs/http/interface";

// domain
import {
    ProblemRepository,
    RequestGetProblemsByCurriculumIds,
    RequestGetProblemsByProblemIds,
} from "@/entities/problem/domain/repository";
import type { GetProblemsResponseDto, ProblemDto } from "@/entities/problem/domain/dtos";

@singleton()
export default class ProblemRepositoryImpl implements ProblemRepository {
    constructor(@inject("HttpAdapter") private readonly server: HttpAdapter) {}

    getProblemsByCurriculumIds = async (payload: RequestGetProblemsByCurriculumIds) => {
        let url = `/v1/problems?`;

        // curriculumId query
        payload.curriculumIds.forEach((curriculumId) => {
            url += `curriculumId=${curriculumId}&`;
        });

        // timeDifficulty query
        payload.timeDifficulties.forEach((timeDifficulty) => {
            url += `timeDifficulty=${timeDifficulty}&`;
        });

        url += `size=${payload.size}&`;

        if (payload.nextToken) {
            url += `nextToken=${payload.nextToken}`;
        }

        const response = await this.server.get<GetProblemsResponseDto>(url);

        return response;
    };

    getProblemsByProblemIds = async (payload: RequestGetProblemsByProblemIds) => {
        let url = `/v1/problems?`;

        payload.problemIds.forEach((id) => {
            url += `problemId=${id}&`;
        });

        url += `size=${payload.size}`;

        if (payload.nextToken) {
            url += `nextToken=${payload.nextToken}`;
        }

        const response = await this.server.get<GetProblemsResponseDto>(url);

        return response;
    };

    getProblemByProblemId = async (problemId: number) => {
        const response = await this.server.get<ProblemDto>(`/v1/problems/${problemId}`);

        return response;
    };

    /**
     * @description 문항 정보 불러오기
     * @deprecated 추후 사용하지 않을 예정입니다.
     */
    getScaffoldCommentaryByProblemId = async (problemId: number) => {
        const response = await this.server.get<string>(
            `/v1/problems/${problemId}/scaffold-commentary`,
        );

        return response;
    };
}
